var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99622 13.0004V5.99752C2.99622 4.33983 4.33978 2.99627 5.99747 2.99627H18.0025C19.6602 2.99627 21.0037 4.33983 21.0037 5.99752V18.0025C21.0037 19.6602 19.6602 21.0038 18.0025 21.0038H12",
    stroke: "#003541",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6864 11.2814L12.6682 13.2632L15.5014 10.4961C15.5384 10.46 15.6004 10.4721 15.6225 10.5181C16.3558 12.0857 16.0126 14.0165 14.7171 15.3111C13.4626 16.5656 11.6788 16.8957 10.1592 16.3015L5.98644 20.4742C5.30216 21.1575 4.1927 21.1575 3.50941 20.4742C2.82613 19.7899 2.82613 18.6805 3.50941 17.9972L7.64914 13.8575C7.05389 12.3388 7.38503 10.5551 8.63955 9.29957C9.93209 8.00703 11.8589 7.72591 13.4275 8.39719C13.4746 8.4182 13.4866 8.48223 13.4506 8.51924L10.6864 11.2814Z",
    stroke: "#003541",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestIcon);
export default __webpack_public_path__ + "static/media/request-icon.24d217b92ae92fa1a241f278d17bc002.svg";
export { ForwardRef as ReactComponent };